import { styled } from '@linaria/react';
import RightChevron from './svg/chevron.svg?react';
import { globalCssVariables } from '../Page/PageGlobalStyles';

export const StyledRightChevron = styled(RightChevron)`
  width: 40px;
  transform: rotate(calc(var(${globalCssVariables.flowDirection}) * -90deg));
`;
